import mainLogo from '../../images/NissulYamaha/NissulYamaha_logo_02_color.png';
import squareLogo from '../../images/NissulYamaha/yamaha_logo_square_color.png';
import squareLogoWhite from '../../images/NissulYamaha/NissulYamaha_logo_white_color.png';
import squareLogoSmall from '../../images/NissulYamaha/NissulYamaha_logo_square_02_color.png';
import banner01 from '../../images/NissulYamaha/banner_01.jpg';
import banner02 from '../../images/NissulYamaha/banner_02.jpg';
import car123 from '../../images/NissulYamaha/123_yamahar3.jpg';
import box123 from '../../images/NissulYamaha/123_yamahar3.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'NissulYamaha',
    defaultStoreLink: 'loja.nissulyamaha.com.br',
    launchDate: '15/05/2023',
    defaultContactEmail: 'atendimento@nissulgala.com',
    whatsappNumber: '53 3025 8400',
    CNPJname: '',
    CNPJ: '04.573.344/0001-40',
    CNPJaddress: 'Avenida Augusto Simoes Lopes, 06 - Tres Vendas, Pelotas/RS - 96.065-030',
    launchDate: '01/05/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'yamaha',
    ],

    homologBrands: [
        // 'motorcraft',
        // 'motrio',
        // 'acdelco',
        // 'mopar',
        // 'bproauto',
    ],

    noVehicle: true,

    storeSellersWarehouses: [
        "NISSUL YAMAHA RIO GRANDE",
    ],

    disabledSellers: [],

    productSlider: [
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.YamahaOleos
        },
        // {
        //     name: 'Óleos',
        //     img: 'tabOleos',
        //     products: SliderProducts.Oleos
        // },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.YamahaFiltros
        },
        {
            name: 'Iluminação',
            img: 'tabLuzes',
            products: SliderProducts.YamahaLuzes
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.YamahaFreios
        },
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.YamahaKits
        },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        //     },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // }
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            50: 2,
            200: 3,
            300: 4,
            500: 5,
            1000: 6,
        }
    },
    
    customShipping: {
        deliveryTime: 1,    
    }
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogoSmall,
    banner01: banner01,
    banner02: banner02,
    banner03: banner02,
    bannerLogoWhite: squareLogoWhite,
    aboutUsBg: banner01,
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    car123: car123,
    box123: box123,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias <mark>Nissul Gala Yamaha</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'A nissul gala é a sua concessionária autorizada Yamaha em Bagé, Cachoeira do Sul, Camaquã, Rio Grande e Sant\'Ana do Livramento. Toda linha de motos Yamaha você encontra nas concessionárias Nissul Gala Yamaha.',
        ],
        link: 'https://www.nissulgala.com.br/sobre-nos/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/nissulgala/',
        Facebook: 'https://www.facebook.com/nissulgala',
        LinkedIn: 'https://www.linkedin.com/company/grupo-nissul-gala',
        Youtube: '',
        Twitter: '',
        Tiktok: 'https://www.tiktok.com/@nissulgala',
    },

    footerContent: [],
}